import React from 'react'

function Dummy() {
  return (
    <div>Dummy</div>
  )
}

export default Dummy